export enum ShipmentCriticalTransitLocations {
  RedSea = 'RED_SEA',
}
